import React from "react";
import { BsFacebook } from "react-icons/bs";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTelegramPlane,
  FaYoutube,
} from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import { MdEmail } from "react-icons/md";
function Footer() {
  return (
    <div>
      <footer class="p-4 bg-gray-50 sm:p-6">
        <div class="mx-auto max-w-screen-xl">
          <div class="md:flex md:justify-between">
            <div class="mb-6 md:mb-0">
              <a href="/" class="flex items-center">
                <img
                  src="./image/1 png.png"
                  class="mr-3 w-40 h-40"
                  alt="Logo"
                />
              </a>
            </div>
            <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
              <div>
                <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase ">
                  Go to
                </h2>
                <ul class="text-gray-600 ">
                  <li class="mb-4">
                    {" "}
                    <div>
                      <a href="./" className="hover:text-blue-400">
                        Home
                      </a>
                    </div>
                  </li>
                  <li class="mb-4">
                    {" "}
                    <div>
                      <a href="./about" className="hover:text-blue-400">
                        About us
                      </a>
                    </div>
                  </li>
                  <li class="mb-4">
                    {" "}
                    <div>
                      <a href="./program" className="hover:text-blue-400">
                        Programs
                      </a>
                    </div>
                  </li>
                  <li class="mb-4">
                    {" "}
                    <div>
                      <a href="./news" className="hover:text-blue-400">
                        News
                      </a>
                    </div>
                  </li>
                  <li>
                    {" "}
                    <div>
                      <a href="./contactus" className="hover:text-blue-400">
                        Contact us
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase ">
                  Follow us
                </h2>
                <ul class="text-gray-600 ">
                  <li class="mb-4">
                    <div>
                      <span className="inline-flex mr-2">
                        <FaFacebookF className="text-blue-500 hover:text-blue-400 " />
                      </span>
                      <a
                        href="https://www.facebook.com/profile.php?id=61559742719810&mibextid=ZbWKwL"
                        target=" _blank"
                      >
                        FaceBook
                      </a>
                    </div>
                  </li>
                  <li class="mb-4">
                    <span className="inline-flex mr-2">
                      <FaLinkedinIn className="text-blue-500 hover:text-blue-400 " />
                    </span>
                    <a
                      href="https://www.linkedin.com/in/meklit-humanitarian-022453296/"
                      target=" _blank"
                    >
                      LinkedIn
                    </a>
                  </li>

                  <li class="mb-4">
                    <span className="inline-flex mr-2">
                      <FaTelegramPlane
                        className="text-blue-500 hover:text-blue-400 "
                        target=" _blank"
                      />
                    </span>
                    <a href="https://t.me/Meklit_Ha">Telegram</a>
                  </li>
                  <li>
                    <span className="inline-flex mr-2">
                      <FaYoutube
                        className="text-blue-500 hover:text-blue-400 "
                        target=" _blank"
                      />
                    </span>
                    <a href="https://youtube.com/@meklitha?si=PG08l6ArIOiM987S">
                      YouTube
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">
                  Address
                </h2>
                <ul class="text-gray-600 ">
                  <li class="mb-4">
                    <p>
                      {" "}
                      <span className="inline-flex mr-2">
                        <MdEmail className="text-blue-500 hover:text-blue-400 " />
                      </span>
                      Contactmeklitha@gmail.com
                    </p>
                  </li>
                  <li>
                    <div>
                      <span className="inline-flex mr-2">
                        <ImLocation className="text-blue-500 hover:text-blue-400 " />
                      </span>
                      Addis Ababa, Ethiopia
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr class="my-6 border-blue-400 sm:mx-auto  lg:my-8 " />
          <div class="sm:flex sm:items-center sm:justify-between">
            <span class="text-sm text-gray-500 sm:text-center ">
              © 2023{" "}
              <a href="." class="hover:underline">
                Herani Tech
              </a>
              . All Rights Reserved.
            </span>
            <div
              className="flex sm:justify-center space-x-6 animate__animated
                 animate__pulse animate__delay-1s animate__infinite"
            >
              <a
                href="https://www.facebook.com/profile.php?id=61551149005409"
                target=" _blank"
                className="text-blue-500 hover:text-blue-400"
              >
                <BsFacebook className="h-5  w-5" />
              </a>

              <a
                href="https://www.linkedin.com/in/meklit-humanitarian-022453296/"
                target=" _blank"
                className="text-blue-500 hover:text-blue-400"
              >
                <FaLinkedinIn className="h-5 w-5" />
              </a>
              <a
                href="https://t.me/gebrheir"
                className="text-blue-500 hover:text-blue-400"
                target=" _blank"
              >
                <FaTelegramPlane className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com/@Meklit Humanitarian Association Project"
                className="text-blue-500 hover:text-blue-400"
                target=" _blank"
              >
                <FaYoutube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <script src="https://unpkg.com/flowbite@1.4.7/dist/flowbite.js"></script>
    </div>
  );
}

export default Footer;
